//ALL API END POINTS
import { ROOT_URL } from "./constant";

const PREFIX = `${ROOT_URL}/api`;

export const AUTO_SUGGEST_API = `${PREFIX}/keyword/auto-suggest`;
export const AUTO_SUGGEST_PROFILE_API = `${PREFIX}/auto-suggest/full-profile`;
export const AUTO_SUGGEST_TERMS_API = `${PREFIX}/auto-suggest/terms`;
export const EXPERTS_SEARCH_API = `${PREFIX}/keyword/expert-search`;
export const EXPERT_SEARCH_TOPIC_HINDEX_API = `${PREFIX}/keyword/expert-search/topic-hindex`;
export const EXPERTS_SUMMARY_API = `${PREFIX}/keyword/result-summary`;
export const EXPERTS_REALTED_TERMS_API = `${PREFIX}/keyword/related-terms`;
export const TWEETS_API = `${PREFIX}/keyword/tweets`;
export const LOCATIONS_API = `${PREFIX}/keyword/location`;
export const AUTO_SUGGEST_DRUG_AND_CONDITION_API = `${PREFIX}/liv/drug-condition/suggest`;
export const LIV_USER_PROFILE_API = `${PREFIX}/profile`;
export const PATENTS_MAIN_SEARCH_API = `${PREFIX}/liv/search/patents-main`;

//location table api
export const LOCATIONS_TABLE_API = `${PREFIX}/keyword/location/experts`;

//expert collab api
export const EXPERT_COLLAB_API = `${PREFIX}/arun/has_to/send`;
//prev affiliation api
export const PREV_AFF_API = `${PREFIX}/arun/has_to/send`;

//expert collaborator network by profile api
export const EXPERT_COLLABORATOR_NETWORK_PROFILE_API = `${PREFIX}/collabs/profile/network`;

//recent Searches API
export const USER_SEARCHES_API = `${PREFIX}/user/recent-searches`;

export const REPORT_MISTAKE_API = `${PREFIX}/liv/report-mistake`;

//Peer Review api
export const PEER_REVIEW_API = `${PREFIX}/liv/peer-reviewer/keyword-extractor`;

export const ABSTRACT_STORE_API = `${PREFIX}/liv/abstractkeyword/store`;

//Aff credentials api
export const AFF_CREDENTIALS_API = `${PREFIX}/liv/aff/credentials`;

//Aff experts api
export const AFF_EXPERTS_API = `${PREFIX}/liv/aff/experts`;

//Aff articles api
export const AFF_ARTICLES_API = `${PREFIX}/liv/aff/articles`;

export const CLINICAL_TRIALS_API = `${PREFIX}/keyword/clinical-trials`;

export const EXPERT_ARTICLES_API = `${PREFIX}/experts-bio/articles`;
export const EXPERT_BIO_COLLABS_API = `${PREFIX}/experts-bio/top-collaborators`;
export const EXPERT_GRANTS_API = `${PREFIX}/expert-bio/grants`;
export const EXPERT_HISTOGRAM_API = `${PREFIX}/experts-bio/histogram`;
export const EXPERT_TRIALS_API = `${PREFIX}/experts-bio/clinical-trials`;
export const EXPERT_CREDENTIALS_API = `${PREFIX}/experts-bio/credentials`;
export const EXPERTS_EXTERNAL_LINKS_API = `${PREFIX}/experts-bio/external-links`;
export const EXPERT_MSA_ARTICLES_API = `${PREFIX}/liv/ms-articles`;
export const OPEN_PAYEMENT = `${PREFIX}/liv/open_payment`;

//keyword rank api
export const KEYWORD_REQUEST_API = `${PREFIX}/expert/keyword-rank`;

export const TOPIC_HISTOGRAM_API = `${PREFIX}/topics/histogram`;
export const TOPIC_ARTICLE_API = `${PREFIX}/topics/articles`;
export const EXPERT_COLLABORATOR_NETWORK_API = `${PREFIX}/collabs/keyword/network`;
export const COLLABORATOR_NETWORK_KEYWORD_SHORTEST_PATH_API = `${PREFIX}/collabs/keyword/network/shortest-path`;
export const EXPERT_COLLABS_INFO_API = `${PREFIX}/expert/collabs`;
export const EXPERT_KEYWORD_NETWORK_API = `${PREFIX}/keyword/network`;
export const EXPERTS_PROFILE_SEARCH_API = `${PREFIX}/expert-profile/name/suggest`;
export const EXPERTS_AFFILIATION_PROFILE_SEARCH_API = `${PREFIX}/expert-profile/aff/suggest`;
export const LIV_ANALYTICS_API = `${PREFIX}/liv/analytics`;
export const USER_REGISTERATION_API = `${PREFIX}/user/register/request`;
export const USER_LOGIN_API = `${PREFIX}/user/login`;
export const RELATED_CORPORATE_LINKS_API = `${PREFIX}/keyword/corporates`;
export const EXPERT_MULTI_SEARCH_API = `${PREFIX}/keyword/experts/multi-search`;
export const LOCATION_SUGGESTION_API = `${PREFIX}/uk/location-suggest`;

export const EXPERTS_MULTI_REALTED_TERMS_API = `${PREFIX}/keyword/multi/related-terms`;
export const MULTI_CORPORATES_API = `${PREFIX}/keyword/multi/related-corporates`;
export const MULTI_SUMMARY_API = `${PREFIX}/keyword/multi/result-summary`;
export const EXPERT_BIO_COLLABS_MULTI_API = `${PREFIX}/expert-bio/collabs/multi-keyword`;
export const EXPERT_ARTICLES_MULTI_API = `${PREFIX}/expert-bio/articles/multi-keyword`;
export const INSTITUTES_API = `${PREFIX}/liv/institute/search`;
export const GET_ABSTRACT_FROM_FILE = `${PREFIX}/liv/abstractfile/getText`;

//seniority schema api
export const SENIOR_SCHEMA_API = `${PREFIX}/liv/seniority/schema`;

//get aff trials api
export const AFF_TRIALS_API = `${PREFIX}/trial-sites`;

//get socmed vs citation api
export const GET_SOCMED_CITATION_API = `${PREFIX}/keyword/experts/soc-vs-ciation`;

//get social citation api
export const AFF_SOCIAL_CITATION_API = `${PREFIX}/keyword/experts/citation`;

//trial-location-api
export const LOCATION_TRIAL_API = `${PREFIX}/trial-sites/location`;

//grants api
export const KEYWORD_GRANTS_API = `${PREFIX}/keyword/grants/search`;
export const KEYWORD_GRANTS_PUBLICATION_API = `${PREFIX}/keyword/grants/publications`;

//twitter conference api
export const KEYWORD_TWITTER_CONF_API = `${PREFIX}/twitter/conference/search`;

//mld professionals
export const MLD_PROFESSIONALS_API = `${PREFIX}/mld-professionals/search`;

export const MLD_PUBLICATION_INFO_API = `${PREFIX}/mld/publications`;

export const CLINICAL_TRIALS_ID_API = `${PREFIX}/clinical/trial-site-id`;

//expert link edit api
export const EDIT_EXPERT_LINK_API = `${PREFIX}/expert/links/edit`;
export const AFF_LINKS_UPDATE_API = `${PREFIX}/institute/links/edit`;
export const MLD_AUTO_SUGGEST_API = `${PREFIX}/mld/auto-suggest`;
export const EXPERT_TAG_SUGGEST_API = `${PREFIX}/expert/tagg-suggest`;

//mld social bodies
export const MLD_SOCIAL_BODY_API = `${PREFIX}/mld/social`;

//mld clinical trials
export const MLD_CLINICAL_TRIALS_API = `${PREFIX}/mld/clinical-trials`;

export const MLD_SOCIAL_CONF_API = `${PREFIX}/mld/conf`;
//mld short list
export const MLD_SHORT_LIST_SAVE_API = `${PREFIX}/mld/experts/save`;
export const MLD_SHORT_LIST_PROFESSIONALS_API = `${PREFIX}/mld/experts/short-listed`;
export const MLD_SELECTED_LIST_PROFESSIONALS_API = `${PREFIX}/mld/experts/selected`;
export const MLD_EXPERTS_REMOVE_API = `${PREFIX}/mld/experts/remove`;
export const CONF_UPDATE_API = `${PREFIX}/conf/update`;
export const MLD_INVOLVED_USERS_API = `${PREFIX}/app/involved/users`;

//society update api
export const SOCIETY_UPDATE_API = `${PREFIX}/society/update`;

//mld affiliations
export const MLD_AFFILIATIONS_API = `${PREFIX}/mld/universities`;

//mld location api
export const MLD_LOCATIONS_API = `${PREFIX}/mld/location`;
export const MLD_LOCATION_SUMMARY_API = `${PREFIX}/mld/location/summary`;

//mld collaborator api
export const MLD_COLLABS_NETWORK_API = `${PREFIX}/mld/collabs-network`;

//mld shortest path api
export const MLD_COLLABS_NETWORK_SHORT_PATH_API = `${PREFIX}/mld/collabs-network/shortest-path`;
export const MLD_COLLABS_CONNECTIONS_COUNT_API = `${PREFIX}/mld/collabs-counts`;

//mld medical bodies api
export const MLD_MEDICA_BODY_API = `${PREFIX}/mld/medical-bodies`;

//kol mapping api
export const KOL_MAPPING_API = `${PREFIX}/liv/kol`;
export const KOL_EXPERTS_ARTICLES_API = `${PREFIX}/liv/kol/articles`;
export const KOL_UPLOAD_FILE_API = `${PREFIX}/liv/kol/upload-file`;
export const KOL_SAVE_RESULTS_API = `${PREFIX}/liv/kol/save-result`;
export const KOL_GET_SAVE_RESULTS_API = `${PREFIX}/liv/kol/get-save-result`;

//euro network api
export const EURO_NETWORK_API = `${PREFIX}/euro/network`;

//trials
export const TRIALS_INSTITUTES_API = `${PREFIX}/liv/trials/institutes`;
export const TRIALS_ENDPOINTS_API = `${PREFIX}/liv/trials/endpoints`;
export const TRIALS_INSTITUTES_TRIALS_API = `${PREFIX}/liv/trials/infos`;
export const TRIALS_MAIN_API = `${PREFIX}/liv/trials/main`;
export const TRIALS_CLINICAL_SITES_API = `${PREFIX}/liv/trials/trial-sites`;
export const TRIALS_MAIN_DOWNLOAD_API = `${PREFIX}/liv/trial/main/download`;

export const UPDATE_ERN_API = `${PREFIX}/ERN/update`;
export const TRIALS_PHASES_API = `${PREFIX}/liv/trials/phases`;
export const TRIALS_PARTNER_AFF_API = `${PREFIX}/liv/trials/partner-aff`;

//mld clinical trials
export const MLD_CLINICAL_TRIALS_EXPERTS_API = `${PREFIX}/mld/trials/investigators`;
export const MLD_CLINICAL_TRIALS_INSTITUTE_API = `${PREFIX}/mld/trials/sites`;
export const MLD_CLINICAL_TRIALS_COUNTRY_API = `${PREFIX}/mld/trials/locations`;
export const MLD_CLINICAL_TRIALS_INFO_API = `${PREFIX}/mld/trials/info`;
export const MLD_SHORT_LIST_REMOVED_PROFESSIONALS_API = `${PREFIX}/mld/experts/short-listed-removed`;

//mld summary api
export const MLD_CLINICAL_SUMMARY_API = `${PREFIX}/mld/overall-summary`;
export const EXPERTS_MLD_ARTICLES_API = `${PREFIX}/experts/mld-articles`;

export const EXPERTS_COLLABS_SHARED_INFOS_API = `${PREFIX}/expert-bio/collabs/shared-info`;

export const LINK_PREVIEW_API = `${PREFIX}/liv/link-preview`;
export const MLD_HOME_SEARCH_API = `${PREFIX}/home/mld`;

//ald clinical trials
export const ALD_CLINICAL_TRIALS_EXPERTS_API = `${PREFIX}/ald/trials/investigators`;
export const ALD_CLINICAL_TRIALS_INSTITUTE_API = `${PREFIX}/ald/trials/sites`;
export const ALD_CLINICAL_TRIALS_COUNTRY_API = `${PREFIX}/ald/trials/locations`;
export const ALD_CLINICAL_TRIALS_INFO_API = `${PREFIX}/ald/trials/info`;
export const ALD_SHORT_LIST_REMOVED_PROFESSIONALS_API = `${PREFIX}/ald/experts/short-listed-removed`;

//Ald summary api
export const ALD_CLINICAL_SUMMARY_API = `${PREFIX}/ald/overall-summary`;
export const EXPERTS_ALD_ARTICLES_API = `${PREFIX}/experts/ald-articles`;
//Ald affiliations
export const ALD_AFFILIATIONS_API = `${PREFIX}/ald/universities`;
//ald location api
export const ALD_LOCATIONS_API = `${PREFIX}/ald/location`;
export const ALD_LOCATION_SUMMARY_API = `${PREFIX}/ald/location/summary`;
//ald collaborator api
export const ALD_COLLABS_NETWORK_API = `${PREFIX}/ald/collabs-network`;
//ald medical bodies api
export const ALD_MEDICA_BODY_API = `${PREFIX}/ald/medical-bodies`;

//mld professionals
export const ALD_PROFESSIONALS_API = `${PREFIX}/ald-professionals/search`;

//ald social bodies
export const ALD_SOCIAL_BODY_API = `${PREFIX}/ald/social`;
//ald clinical trials
export const ALD_CLINICAL_TRIALS_API = `${PREFIX}/ald/clinical-trials`;
//ALD CONF API
export const ALD_SOCIAL_CONF_API = `${PREFIX}/ald/conf`;
//ald short list
export const ALD_SHORT_LIST_SAVE_API = `${PREFIX}/ald/experts/save`;
export const ALD_SHORT_LIST_PROFESSIONALS_API = `${PREFIX}/ald/experts/short-listed`;
export const ALD_SELECTED_LIST_PROFESSIONALS_API = `${PREFIX}/ald/experts/selected`;
export const ALD_EXPERTS_REMOVE_API = `${PREFIX}/ald/experts/remove`;
export const ALD_INVOLVED_USERS_API = `${PREFIX}/ald/involved/users`;
export const ALD_AUTO_SUGGEST_API = `${PREFIX}/ald/auto-suggest`;

//nipt professionals api
export const NIPT_PROFESSIONALS_API = `${PREFIX}/nipt/long-experts`;
export const NIPT_EXPERTS_REMOVE_API = `${PREFIX}/nipt/experts/remove`;
export const NIPT_SHORT_LIST_SAVE_API = `${PREFIX}/nipt/experts/save`;
export const NIPT_SHORT_LIST_PROFESSIONALS_API = `${PREFIX}/nipt/experts/short-listed`;
export const NIPT_SELECTED_LIST_PROFESSIONALS_API = `${PREFIX}/nipt/experts/selected`;
export const NIPT_LOCATIONS_API = `${PREFIX}/nipt/location`;
export const NIPT_AFFILIATIONS_API = `${PREFIX}/nipt/universities`;
export const NIPT_COLLABS_NETWORK_API = `${PREFIX}/nipt/collabs-network`;
export const NIPT_CLINICAL_SUMMARY_API = `${PREFIX}/nipt/overall-summary`;
export const EXPERTS_NIPT_ARTICLES_API = `${PREFIX}/experts/nipt-articles`;
export const NIPT_LOCATION_SUMMARY_API = `${PREFIX}/nipt/location/summary`;
export const NIPT_AUTO_SUGGEST_API = `${PREFIX}/nipt/auto-suggest`;
export const NIPT_GRANTS_API = `${PREFIX}/nipt/grants`;

export const NIPT_MEDICAL_BODIES_API = `${PREFIX}/nipt/medical-bodies`;
export const NIPT_CONF_API = `${PREFIX}/nipt/conf`;
export const NIPT_FUNDING_ORG_API = `${PREFIX}/nipt/funding-org`;

export const ADD_EXPERTS_GRANTS_API = `${PREFIX}/liv/grants/add`;
export const EDIT_EXPERTS_GRANTS_API = `${PREFIX}/liv/grants/edit`;
export const REMOVE_EXPERTS_GRANTS_API = `${PREFIX}/liv/grants/remove`;

//nipt clinical trials
export const NIPT_CLINICAL_TRIALS_API = `${PREFIX}/nipt/clinical-trials`;
export const NIPT_CLINICAL_TRIALS_EXPERTS_API = `${PREFIX}/nipt/trials/investigators`;
export const NIPT_CLINICAL_TRIALS_INSTITUTE_API = `${PREFIX}/nipt/trials/sites`;
export const NIPT_CLINICAL_TRIALS_COUNTRY_API = `${PREFIX}/nipt/trials/locations`;
export const NIPT_CLINICAL_TRIALS_INFO_API = `${PREFIX}/nipt/trials/info`;

export const RELATED_CONCEPT_SUGGESTIONS_API = `${PREFIX}/liv/related-concepts/suggestions`;

export const RELATED_CONCEPT_RESULT_API = `${PREFIX}/liv/related-concepts/concepts`;

export const ROTA_APPLICATION_ADD_CLINIC_API = `${PREFIX}/liv/rota-application/clinic`;
export const ROTA_APPLICATION_GET_CLINIC_API = `${PREFIX}/liv/rota-application/get-clinic`;
export const ROTA_APPLICATION_EDIT_CLINIC_API = `${PREFIX}/liv/rota-application/edit-clinic`;
export const ROTA_APPLICATION_DELETE_CLINIC_API = `${PREFIX}/liv/rota-application/delete-clinic`;
export const ROTA_APPLICATION_ADD_DOCTOR_API = `${PREFIX}/liv/rota-application/add-doctors`;

export const ABSTRACT_CONCEPT_RESULT_API = `${PREFIX}/liv/concept-mapping`;

//ROTA APPLICATION  API
export const ROTA_APPLICATION_CLINIC_API = `${PREFIX}/liv/rota/clinics`;
export const ROTA_APPLICATION_CLINIC_DETAILS_API = `${PREFIX}/liv/rota/clinic-details`;
export const ROTA_APPLICATION_CLINIC_EVENT_DETAILS_API = `${PREFIX}/liv/rota/clinicic-event-details`;
export const LIV_NOTES_API = `${PREFIX}/liv/notes`;
export const ROTA_APPLICATION_CLINICIAN_API = `${PREFIX}/liv/rota/doctors`;
export const ROTA_APPLICATION_CLINICIAN_DETAILS_API = `${PREFIX}/liv/rota/clinician-details`;

//ROTA DOCTORS
export const ROTA_NEW_DOCTOR_API = `${PREFIX}/liv/rotav1/doctors`;
export const ROTA_NEW_DOCTOR_LEAVE_API = `${PREFIX}/liv/rotav1/doctors/leave`;

//ROTA MANAGEMENT
export const ROTA_MANAGEMENT_ONCALL_API = `${PREFIX}/liv/rotav1/management/oncalls`;
export const ROTA_MANAGEMENT_LEAVES_API = `${PREFIX}/liv/rotav1/management/leaves`;
export const ROTA_NEW_ADMIN_API = `${PREFIX}/liv/rotav1/management/admin`;

//ROCKET PHARMA
export const ROCKET_PHARMA_LAD_PATIENT_API = `${PREFIX}/liv/rocket/lad/patients`;
export const ROCKET_PHARMA_DANON_PATIENT_API = `${PREFIX}/liv/rocket/danon/patients`;
export const ROCKET_PHARMA_CROS_API = `${PREFIX}/liv/rocket/cros`;
export const ROCKET_PHARMA_DANON_MBODIES_API = `${PREFIX}/liv/rocket/danon/mbodies`;
export const ROCKET_PHARMA_LAD_MBODIES_API = `${PREFIX}/liv/rocket/lad/mbodies`;
export const ROCKET_PHARMA_DANON_CONF_API = `${PREFIX}/liv/rocket/danon/conf`;
export const ROCKET_PHARMA_LAD_CONF_API = `${PREFIX}/liv/rocket/lad/conf`;

//clinic time table
export const ROTA_CLINIC_TIME_TABLE_API = `${PREFIX}/liv/rota/clinicic-timetable`;

//peer reviewer
export const PEER_REVIEWER_RESULT_API = `${PREFIX}/liv/peer-reviewer/result`;
export const PEER_REVIEWER_KEYWORD_API = `${PREFIX}/liv/peer-reviewer/keywords`;

export const EXPERT_DIRECT_PROFILE_SUGGEST_API = `${PREFIX}/liv/direct-profile-suggest`;

//ALACRITA
export const ALACRITA_LGMD2C_API = `${PREFIX}/liv/alacrita/lgmd2c`;
export const ALACRITA_DEFINITIONS_API = `${PREFIX}/liv/alacrita/definitions`;
export const ALACRITA_TRIALS_API = `${PREFIX}/liv/alacrita/trials`;
export const ALACRITA_EPIDEMIOLOGY_API = `${PREFIX}/liv/alacrita/epidemiology`;
export const ALACRITA_TRIAL_SITES_API = `${PREFIX}/liv/alacrita/trial-sites`;

export const PERSON_SIMILARITY_RESULT_API = `${PREFIX}/liv/person-similarity`;

//MLD TWEETS
export const MLD_TWEET_SUMMARY_API = `${PREFIX}/liv/mld-tweet-summary`;
export const MLD_TWEET_USER_NETWORK = `${PREFIX}/liv/mld-tweet-user-network`;
export const MLD_TWEET_RELATED_TERMS = `${PREFIX}/liv/mld-tweet-related-terms`;
export const MLD_TWEET_SENTIMENT = `${PREFIX}/liv/mld-tweet-sentiment`;
export const MLD_TWEET_DETAILS = `${PREFIX}/liv/mld-tweet-details`;
export const CONF_TWITTER_HANDLER_API = `${PREFIX}/liv/conf/twitter/handler`;

//KEY AREAS
export const LIV_EXPERTS_KEYAREA_API = `${PREFIX}/liv/expert-keyareas`;

//MLD NEW APIS
export const MLD_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/liv/mld/main-experts`;
export const MLD_MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/mld/main-experts/save`;
export const MLD_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/liv/mld/main-experts/remove`;

//MAIN EXPERTS SAVE API
export const MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/experts/save`;
export const CONF_TWITTER_MAIN_NETWORK_API = `${PREFIX}/liv/conf/main-network`;

//WAS EXPERTS API
export const WAS_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/liv/was/main-experts`;
export const WAS_MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/was/main-experts/save`;
export const WAS_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/liv/was/main-experts/remove`;

//WAS LOCATIONS API
export const WAS_LOCATON_SUMMARY_API = `${PREFIX}/was/location/summary`;

//WAS AFFILIATION API
export const WAS_AFFILIATIONS_API = `${PREFIX}/was/universities`;

//WAS COLLABS NETWORK API
export const WAS_COLLABS_NETWORK_API = `${PREFIX}/was/collabs-network`;
export const WAS_COLLABS_NETWORK_SHORT_PATH_API = `${PREFIX}/was/collabs-network/shortest-path`;

//WAS MEDICAL BODY API
export const WAS_MEDICA_BODY_API = `${PREFIX}/was/medical-bodies`;

//WAS CONF API
export const WAS_CONF_API = `${PREFIX}/was/conf`;

//WAS SUMMARY API
export const WAS_SUMMARY_API = `${PREFIX}/was/overall-summary`;

//WAS CLINICAL TRIALS
export const WAS_CLINICAL_TRIALS_API = `${PREFIX}/was/clinical-trials`;
export const WAS_TRIALS_INVESTIGATORS_API = `${PREFIX}/was/trials/investigators`;
export const WAS_TRIALS_LOCATIONS_API = `${PREFIX}/was/trials/locations`;
export const WAS_TRIALS_SITES_API = `${PREFIX}/was/trials/sites`;
export const WAS_CLINICAL_TRIALS_INFO_API = `${PREFIX}/was/trials/info`;

//WAS PUBLICAITON INFO API
export const WAS_PUBLICATION_INFO_API = `${PREFIX}/was/publications`;
export const EXPERTS_WAS_ARTICLES_API = `${PREFIX}/experts/was-articles`;

//ERN NETWORK API
export const LIV_ERN_NETWORK_API = `${PREFIX}/liv/ern/network`;

//MLD USER MANUAL API
export const MLD_USER_MANUAL = `${PREFIX}/liv/mld/user-manual`;

//MY ACCOUNT API
export const LIV_MY_ACCOUNT_API = `${PREFIX}/liv/user/account`;
export const LIV_MY_ACCOUNT_SUBSCRIPTION = `${PREFIX}/liv/user/subscription`;
export const LIV_MY_ACCOUNT_PASSWORD_UPDATE_API = `${PREFIX}/liv/user/update-password`;

//KEYWORD COLLABS NETWORK API
export const COLLABORATOR_NETWORK_KEYWORD_SPECIFIC_API = `${PREFIX}/liv/network/keyword-based`;

//NEW NIPT APIS
export const NIPTAPP_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/liv/niptapp/main-experts/search`;
export const NIPTAPP_AFFILIATIONS_API = `${PREFIX}/liv/niptapp/institutes`;
export const NIPTAPP_LOCATON_SUMMARY_API = `${PREFIX}/liv/niptapp/location-summary`;

export const NIPTAPP_MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/niptapp/main-experts/save`;
export const NIPTAPP_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/liv/niptapp/main-experts/remove`;
export const NIPTAPP_SUMMARY_API = `${PREFIX}/niptapp/overall-summary`;
export const NIPTAPP_COLLABS_NETWORK_API = `${PREFIX}/niptapp/collabs-network`;

export const NIPTAPP_CLINICAL_TRIALS_API = `${PREFIX}/niptapp/clinical-trials`;
export const NIPTAPP_TRIALS_INVESTIGATORS_API = `${PREFIX}/niptapp/trials/investigators`;
export const NIPTAPP_TRIALS_LOCATIONS_API = `${PREFIX}/niptapp/trials/locations`;
export const NIPTAPP_TRIALS_SITES_API = `${PREFIX}/niptapp/trials/sites`;

export const LIV_COLLABS_SOURCE_INFOS_API = `${PREFIX}/liv/collabs/sources`;

//zogenix
export const ZOGENIX_SPECIALTY_MAP_API = `${PREFIX}/liv/zogenxi/specialty/map`;
export const ZOGENIX_SPECIALTY_CARD_API = `${PREFIX}/liv/zogenxi/specialty/card`;
export const ZOGENIX_SPECIALTY_SUMMARY_API = `${PREFIX}/liv/zogenxi/specialty/summary`;

//dashboard api
export const APP_DASHBOARD_INFO_API = `${PREFIX}/liv/app/dashboard`;
export const APP_GENERAL_DASHBOARD_INFO_API = `${PREFIX}/liv/general/dashboard`;
export const APP_DASBOARD_PUBLICATIONS_API = `${PREFIX}/liv/app/dashboard/publications`;

//social media api
export const APP_SOCIAL_MEDIA_API = `${PREFIX}/liv/app/social-media`;
export const APP_SOCIAL_MEDIA_NETWORK_API = `${PREFIX}/liv/app/social-media/network`;
export const APP_SOCIAL_MEDIA_PROFILE_TWEETS_API = `${PREFIX}/liv/app/social-media/profile-tweets`;

//user track api
export const USER_TRACK_API = `${PREFIX}/liv/user-tracker`;

//rare disease
export const RARE_DISEASE_EVENT_API = `${PREFIX}/liv/app/rare-disease/envent`;
export const RARE_DISEASE_EVENT_TWEETS_API = `${PREFIX}/liv/app/rare-disease/envent/tweets`;
export const RARE_DISEASE_NETWORK_API = `${PREFIX}/liv/app/rare-disease/network`;
export const RARE_DISEASE_PROFILE_API = `${PREFIX}/liv/app/rare-disease/profile`;
export const RARE_DISEASE_PROFILE_TWEETS_API = `${PREFIX}/liv/app/rare-disease/profile/tweets`;

//zogenix
export const ZOGENIX_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/liv/zogenix/main-experts`;
export const ZOGENIX_MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/zogenix/main-experts/save`;
export const ZOGENIX_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/liv/zogenix/main-experts/remove`;

export const ZOGENIX_SUMMARY_API = `${PREFIX}/zogenix/overall-summary`;
export const ZOGENIX_MEDICA_BODY_API = `${PREFIX}/zogenix/medical-bodies`;

// to remove ////////////////////
export const ZOGENIX_LOCATON_SUMMARY_API = `${PREFIX}/app/experts/locations`;
export const ZOGENIX_AFFILIATIONS_API = `${PREFIX}/app/experts/institutes`;

// ////////////////////
export const ZOGENIX_CLINICAL_TRIALS_API = `${PREFIX}/zogenix/clinical-trials`;
export const ZOGENIX_TRIALS_LOCATIONS_API = `${PREFIX}/zogenix/trials/locations`;
export const ZOGENIX_TRIALS_INVESTIGATORS_API = `${PREFIX}/zogenix/trials/investigators`;
export const ZOGENIX_TRIALS_SITES_API = `${PREFIX}/zogenix/trials/sites`;
export const ZOGENIX_COLLABS_NETWORK_API = `${PREFIX}/zogenix/collabs-network`;
export const ZOGENIX_COLLABS_NETWORK_SHORT_PATH_API = `${PREFIX}/zogenix/collabs-network/shortest-path`;
export const ZOGENIX_MAIN_EXPERTS_SUMMARY_SEARCH_API = `${PREFIX}/experts-summary/zogenix`;
export const ZOGENIX_MAIN_SOCIAL_MEDIA_API = `${PREFIX}/social-media/zogenix`;
export const ZOGENIX_MAIN_SOCIAL_MEDIA_NETWORK_API = `${PREFIX}/social-media-network/zogenix`;
export const ZOGENIX_MAIN_SOCIAL_MEDIA_PROFILE_TWEETS_API = `${PREFIX}/social-media-profile-tweets/zogenix`;
export const ZOGENIX_MAIN_CONF_SEARCH_API = `${PREFIX}/zogenix/conf`;
export const ZOGENIX_SPECIALTY_CENTRES_API = `${PREFIX}/liv/zogenix/specialty-centres`;

//isns
export const ISNS_EVENT_API = `${PREFIX}/isns/events`;
export const ISNS_PROFILE_API = `${PREFIX}/isns/profile`;

//move the db to long list
export const MOVE_EXPERT_LONG_LIST_API = `${PREFIX}/move/longlist`;
export const CREATE_NEW_EXPERT_AND_MOVE_TO_LONG_LIST_API = `${PREFIX}/create-new-expert`;

//covid-19
export const COVID_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/liv/covid/main-experts`;
export const COVID_MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/covid/main-experts/save`;
export const COVID_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/liv/covid/main-experts/remove`;

export const COVID_LOCATON_SUMMARY_API = `${PREFIX}/covid/location/summary`;
export const COVID_AFFILIATIONS_API = `${PREFIX}/covid/universities`;
export const COVID_CLINICAL_TRIALS_API = `${PREFIX}/covid/clinical-trials`;
export const COVID_TRIALS_LOCATIONS_API = `${PREFIX}/covid/trials/locations`;
export const COVID_TRIALS_INVESTIGATORS_API = `${PREFIX}/covid/trials/investigators`;
export const COVID_TRIALS_SITES_API = `${PREFIX}/covid/trials/sites`;
export const COVID_COLLABS_NETWORK_API = `${PREFIX}/covid/collabs-network`;
export const COVID_COLLABS_NETWORK_SHORT_PATH_API = `${PREFIX}/covid/collabs-network/shortest-path`;
export const COVID_MAIN_ORGS_SEARCH_API = `${PREFIX}/covid/corporates`;

//affiliation profile api end point
export const AFFILIATION_BIO_API = `${PREFIX}/institute/bio`;

//cardiologist

export const CARDIO_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/liv/cardio/main-experts`;
export const CARDIO_MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/cardio/saveExperts`;
export const CARDIO_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/liv/cardio/removeExperts`;

//newborn experts api
export const NEWBORN_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/liv/newborn/main-experts`;
export const NEWBORN_MAIN_EXPERTS_SAVE_API = `${PREFIX}/liv/newborn/main-experts/save`;
export const NEWBORN_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/liv/newborn/main-experts/remove`;

export const NEWBORN_LOCATON_SUMMARY_API = `${PREFIX}/newborn/location/summary`;
export const NEWBORN_AFFILIATIONS_API = `${PREFIX}/newborn/universities`;

// app-specific apis
export const APP_SPECIALTY_CENTRE_API = `${PREFIX}/app/specialty-centre`;
export const APP_CONGRESSES_API = `${PREFIX}/app/congresses`;
export const APP_MEDICAL_BODY_API = `${PREFIX}/app/medical-bodies`;
export const APP_CLINICAL_TRIALS_API = `${PREFIX}/app/trials`;
export const APP_LOCATON_SUMMARY_API = `${PREFIX}/app/experts/locations`;

// patents apis
export const PATENTS_MAIN_API = `${PREFIX}/patent/experts`;

// events-network
export const ALL_EVENTS_NETWORK_API = `${PREFIX}/events-network`;
export const EVENTS_NETWORK_MAIN_API = `${PREFIX}/main-events-network`;
export const EVENTS_NETWORK_CONTACTS_CHECK_API = `${PREFIX}/app/contacts/check-email`;
export const GET_APP_CONTACTS = `${PREFIX}/app/contacts`;
export const EVENTS_NETWORK_SEARCH_API = `${PREFIX}/search-events-network`;

//api for general congress page
export const GENERAL_CONGRESSES_API = `${PREFIX}/general/congresses`;

// api for classified congress page
export const CLASSIFIED_CONGRESSES_API = `${PREFIX}/classified/congresses`;

//api for general medical bodies
export const GENERAL_MEDICAL_BODIES_API = `${PREFIX}/general/medical-bodies`;

//app landing api
export const APP_HOME_API = `${PREFIX}/app/landing-home`;

//all user related contacts
export const APP_CONTACTS_API = `${PREFIX}/app/contacts`;
export const APP_CONTACTS_EMAIL_CHECK_API = `${PREFIX}/app/contacts/check-email`;
export const APP_CONTACTS_CREATE_API = `${PREFIX}/app/contacts/create`;
export const APP_CONTACT_CONNECTIONS_API = `${PREFIX}/app/contacts/connections`;
export const APP_CONTACT_CONNECTIONS_NETWORK_API = `${PREFIX}/app/contacts/connections/network`;
export const APP_CONTACT_CONNECTIONS_NETWORK_SHORTEST_PATH_API = `${PREFIX}/app/contacts/connections/network/shortest-path`;
export const APP_EVENT_CONTACTS_API = `${PREFIX}/app/contacts/events`;

// app experts api
export const APP_MAIN_EXPERTS_SEARCH_API = `${PREFIX}/app/experts/search`;
export const APP_MAIN_EXPERTS_SAVE_API = `${PREFIX}/app/experts/save`;
export const APP_MAIN_EXPERTS_REMOVE_API = `${PREFIX}/app/experts/remove`;

// app social-media network api
export const APP_MAIN_SOCIAL_MEDIA_NETWORK_API = `${PREFIX}/app/social-media-network`;
export const APP_MAIN_SOCIAL_MEDIA_NETWORK_PROFILES_API = `${PREFIX}/app/social-media-network-profiles`;
export const APP_MAIN_SOCIAL_MEDIA_NETWORK_PROFILES_TWEETS_API = `${PREFIX}/app/social-media-network-profiles-tweets`;
export const APP_SOCIAL_MEDIA_PROFILE_CONNECTIONS_API = `${PREFIX}/app/social-media-network-profiles/connections`;

// app collabs-network
export const APP_NETWORK_API = `${PREFIX}/app/collaborator-network`;
export const APP_COLLABS_NETWORK_SHORT_PATH_API = `${PREFIX}/app/collaborator-network-shortest-path`;

// app definitions
export const APP_TOPIC_DEFINITIONS_API = `${PREFIX}/app/topic-definitions`;
// app affiliations
export const APP_AFFILIATIONS_API = `${PREFIX}/app/experts/institutes`;
// app profile suggesion api
export const APP_PROFILE_SUGGESTION_API = `${PREFIX}/app/main-profile-search`;
//app all users info api
export const APP_ALL_USERS_API = `${PREFIX}/app/user-groups/users`;
//app publication api
export const APP_EXPERT_PUBLICATION_API = `${PREFIX}/app/expert/publications`;
// app criteria
export const APP_MAIN_EXPERTS_SUMMARY_API = `${PREFIX}/app/experts/summary`;
// expert keyword-rank-api
export const APP_EXPERT_KEYWORD_RANKS = `${PREFIX}/app/experts/keyword-ranks`;
// expert ms-articles-api
export const APP_EXPERT_MSA_ARTICLES = `${PREFIX}/app/experts/ms-articles`;
// expert-bio payments-api
export const APP_EXPERT_PAYMENTS_API = `${PREFIX}/app/experts/payments`;

// expert-bio histogram-api
export const APP_EXPERT_BIO_HISTOGRAM = `${PREFIX}/app/expert-bio/histogram`;
// expert-bio grants-api
export const APP_EXPERT_BIO_GRANTS = `${PREFIX}/app/expert-bio/grants`;
// expert-bio top-collabs-api
export const APP_EXPERT_BIO_TOP_COLLABS = `${PREFIX}/app/expert-bio/collabs`;
// expert-bio collabs-multi-api
export const APP_EXPERT_BIO_MULTI_COLLABS = `${PREFIX}/app/expert-bio/multi-collabs`;
// expert-bio credentials-api
export const APP_EXPERT_BIO_CREDENTIALS = `${PREFIX}/app/expert-bio/credentials`;
// expert-bio trials-api
export const APP_EXPERT_BIO_TRIALS = `${PREFIX}/app/expert-bio/trials`;
// expert-bio articles-api
export const APP_EXPERT_BIO_ARTICLES = `${PREFIX}/app/expert-bio/articles`;
// expert-bio multiple-articles-api
export const APP_EXPERT_BIO_MULTI_ARTICLES = `${PREFIX}/app/expert-bio/multi-articles`;
// expert-bio external-links-api 
export const APP_EXPERT_BIO_EXTERNAL_LINKS = `${PREFIX}/app/expert-bio/external-links`;
// expert-bio link-preview-api
export const APP_EXPERT_BIO_LINKS_PREVIEW = `${PREFIX}/app/expert-bio/link-preview`;

// app-other-media-api
export const APP_OTHER_MEDIA_API = `${PREFIX}/app/meint/list`;

// app summary pdf download
export const APP_SUMMARY_PDF_DOWNLOAD_API = `${PREFIX}/app/experts/summary/pdf`;
export const APP_SUMMARY_PDF_DOWNLOAD_DIRECT_API  = `${PREFIX}/app/profile/download`;

//app spain social media index
export const APP_SOCIAL_MEDIA_SPAIN_API = `${PREFIX}/app/social-media-profiles-spain`;

//spain social media profile api
export const APP_SOCIAL_MEDIA_SPAIN_NETWORK_API = `${PREFIX}/app/social-media-profiles-spain-network`;

//spain social media src api
export const APP_SPAIN_SOCIAL_MEDIA_SRCS_API = `${PREFIX}/app/social-media-profiles-spain-network-src`;
export const APP_SPAIN_SOCIAL_MEDIA_CONNECTION_SRCS_API  = `${PREFIX}/app/social-media-profiles-spain-connections-src`;

//spain profile update api
export const APP_SPAIN_SOCIAL_MEDIA_PROFILE_UPDATE_API = `${PREFIX}/app/social-media-profiles-spain-update`;

export const MAIN_PATENT_NEW_INFO_API = `${PREFIX}/liv/search/patents-info`;
export const MAIN_PATENT_MAP_INFO_API = `${PREFIX}/patent/map`;
export const APP_AFFILIATIONS_PROFILE_API  = `${PREFIX}/app/experts/institutes/profile`;
export const APP_APPLICATION_PUBLICATION_API = `${PREFIX}/app/applications/publications`;
export const APP_EXPERTS_SOURCE_API = `${PREFIX}/app/applications/expert/sources`;

export const APP_ADD_NEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/expert/add-new-stakeholders`;
export const APP_SAVE_STAKEHOLDERS_API = `${PREFIX}/app/applications/save-stakeholders`;
export const APP_GET_SAVE_STAKEHOLDERS_API = `${PREFIX}/app/applications/get-save-stakeholders`;
export const APP_UPDATE_SAVE_STAKEHOLDERS_API = `${PREFIX}/app/applications/save-update-stakeholders`;
export const APP_REMOVE_SAVE_STAKEHOLDERS_API = `${PREFIX}/app/applications/save-remove-stakeholders`;

export const APP_GET_NEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/get-new-stakeholders`;
export const APP_REMOVE_NEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/remove-new-stakeholders`;
export const APP_UPDATE_NEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/update-new-stakeholders`;
export const APP_GET_NEW_STAKEHOLDERS_FILTER_OPTIONS_API = `${PREFIX}/app/applications/new-stakeholders-filter-options`;
export const APP_OPTIONS_SAVE_STAKEHOLDERS_API =  `${PREFIX}/app/applications/options-save-stakeholders`;

export const APP_SAVE_VIEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/save-view-stakeholders`;
export const APP_GET_SAVE_VIEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/get-save-view-stakeholders`;
export const APP_UPDATE_SAVE_VIEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/update-save-view-stakeholders`;
export const APP_REMOVE_SAVE_VIEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/remove-save-view-stakeholders`;
export const APP_OPTIONS_SAVE_VIEW_STAKEHOLDERS_API = `${PREFIX}/app/applications/options-save-view-stakeholders`;
export const APP_ERROR_NOTIFICATION_API = `${PREFIX}/app/applications/error-notification`;
